import { TableCellTypes, TypographyColors } from '@carboledger/ui';
import {
  CellText,
  makeUnitTypeCell,
  makeUnitScopedCell,
  makeDiscrepanciesCell,
} from '@/components/common';
import { buildContractStatusVariants } from '@/config/statuses';
import { CONTRACT_STATUS_TONE } from '@/config/statusTones';
import { buildRowUnitOptions } from './incomingShipmentUnits';

// Shipment details ▸ Linked contracts tab.

const renderLinkedShipments = (ctx) => (
  <CellText color={TypographyColors.brand}>{ctx.value}</CellText>
);
const renderUnitType = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));

// Clickable, unlike the plain list-page badge — opens this row's discrepancy modal.
export const buildLinkedContractsColumns = (t, { onOpenDiscrepancy }) => [
  {
    id: 'contractId',
    header: t('FIELD_CONTRACT_ID'),
    type: TableCellTypes.text,
    width: 140,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'linkedShipments',
    header: t('INCOMING_SHIPMENTS_LINKED_CONTRACTS_COL_LINKED_SHIPMENTS'),
    type: TableCellTypes.custom,
    width: 160,
    sortable: true,
    pinnable: true,
    cell: renderLinkedShipments,
  },
  {
    id: 'status',
    header: t('FIELD_STATUS'),
    type: TableCellTypes.statusDot,
    width: 110,
    sortable: true,
    pinnable: true,
    variantMap: buildContractStatusVariants(t, CONTRACT_STATUS_TONE),
  },
  {
    id: 'terminal',
    header: t('FIELD_TERMINAL'),
    type: TableCellTypes.text,
    width: 141,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'unitType',
    header: t('UNIT_TYPE_ARIA'),
    type: TableCellTypes.custom,
    width: 252,
    sortable: true,
    pinnable: true,
    cell: renderUnitType,
  },
  {
    id: 'assignedQty',
    header: t('FIELD_ASSIGNED_QUANTITY_SHIPMENT'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    pinnable: true,
    cell: makeUnitScopedCell('assignedQty'),
  },
  {
    id: 'contractedQuantity',
    header: t('FIELD_CONTRACTED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    pinnable: true,
    cell: makeUnitScopedCell('contractedQuantity'),
  },
  {
    id: 'shippedQuantity',
    header: t('FIELD_SHIPPED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    pinnable: true,
    cell: makeUnitScopedCell('shippedQuantity'),
  },
  {
    id: 'outstandingQuantity',
    header: t('FIELD_OUTSTANDING_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    pinnable: true,
    cell: makeUnitScopedCell('outstandingQuantity'),
  },
  {
    id: 'ghgEmissions',
    header: t('FIELD_GHG_EMISSIONS'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'ghgEmissionSavings',
    header: t('FIELD_GHG_EMISSION_SAVINGS'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'rawMaterialType',
    header: t('FIELD_RAW_MATERIAL_TYPE'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'countryOfOrigin',
    header: t('FIELD_COUNTRY_OF_ORIGIN'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'feedstockCategory',
    header: t('FIELD_FEEDSTOCK_CATEGORY'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'allocationPreference',
    header: t('FIELD_ALLOCATION_PREFERENCE'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'deliverBy',
    header: t('FIELD_DELIVER_BY'),
    type: TableCellTypes.text,
    width: 150,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'discrepancies',
    header: t('FIELD_DISCREPANCIES'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    pinnable: true,
    cell: makeDiscrepanciesCell(onOpenDiscrepancy),
  },
];
